export enum CaceisMessages {
    SUCCESS_CREATE_USER = "Usuário criado com sucesso",
    QUOTA_NOT_FOUND = "Nenhuma Cota encontrada para a data informada.",
    FUND_NOT_FOUND = "Nenhum fluxo de caixa encontrado para a data informada.",
    SERVER_ERROR = "Um erro aconteceu. Por favor, tente novamente mais tarde ou contacte o admnistrador",
    SUCCESS_SAVE_PARAMETER = "Parameter Saved Successfully",
    ERROR_ID_USUARIO = "Please choose another user sso"
}
